<template>
  <div class="prize-wheel-wrapper">
    <FortuneWheel
      :canvas="canvasOptions"
      :prizes="_prizes"
      :verify="canvasVerify"
      :disabled="loading"
      :prizeId="prizeId"
      @rotateStart="onCanvasRotateStart"
      @rotateEnd="onRotateEnd"
    />
  </div>
</template>

<script>
import FortuneWheel from "vue-fortune-wheel";
import "vue-fortune-wheel/lib/vue-fortune-wheel.css";

export default {
  name: "PrizeWheel",

  components: {
    FortuneWheel,
  },

  props: {
    prizes: {
      type: Array,
      default: () => [],
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      prizeId: 0,
      spinSound: null,
      prizeSound: null,
      lostSound: null,
      canvasVerify: true,
      canvasOptions: {
        borderWidth: 12,
        borderColor: "#00305d",
        fontSize: 22,
        btnText: "G",
        textDirection: "vertical",
        btnWidth: this.$vuetify.breakpoint.smAndUp ? 96 : 64,
        textLength: 16,
        textRadius: 230,
      },
      colors: ["#b8ff5b", "#00417e", "#ffffff"],
      finished: false,
    };
  },

  mounted() {
    this.lostSound = new Audio(require("@/assets/sounds/negative.mp3"));
    this.prizeSound = new Audio(require("@/assets/sounds/tada.mp3"));
    this.spinSound = new Audio(require("@/assets/sounds/spin.mp3"));
  },

  computed: {
    _prizes() {
      const count = this.prizes.length;
      const probability = 100 / count;

      let colorIndex = -1;

      return this.prizes.map((el, index) => {
        if (colorIndex === 2) colorIndex = 0;
        else colorIndex++;

        let bgColor = this.colors[colorIndex];

        if (index === this.prizes.length - 1 && bgColor === this.colors[0])
          bgColor = this.colors[1];

        return {
          bgColor: bgColor,
          color: bgColor === this.colors[1] ? "#ffffff" : "#00417e",
          probability: probability,
          weight: 1,
          ...el,
        };
      });
    },
  },

  methods: {
    async onCanvasRotateStart(rotate) {
      try {
        if (this.canvasVerify) {
          this.prizeId = await new Promise((resolve, reject) => {
            this.$emit("started", resolve, reject);
          });

          rotate();

          this.soundTrigger();
        }
      } catch (error) {
        console.error("Erro ao processar a rotação:", error);
      }
    },

    onRotateEnd(event) {
      if (this.finished) return;
      this.finished = true;

      if (event.value === "lost") {
        if (!this.lostSound)
          this.lostSound = new Audio(require("@/assets/sounds/negative.mp3"));

        this.lostSound.play();
      } else {
        if (!this.prizeSound)
          this.prizeSound = new Audio(require("@/assets/sounds/tada.mp3"));

        this.prizeSound.play();
      }

      this.prizeId = 0;
      this.$emit("finished", event);

      // Reset flag depois de um tempo
      setTimeout(() => {
        this.finished = false;
      }, 1000);
    },

    soundTrigger() {
      if (!this.spinSound)
        this.spinSound = new Audio(require("@/assets/sounds/spin.mp3"));

      this.spinSound.play();
    },
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
